module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/schermata4/btn-buy.png"
    },
    on: {
      "click": _vm.sendOrder
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/schermata4/btn-live.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/schermata4/btn-send.png"
    },
    on: {
      "click": _vm.addressEmail
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "popup",
    class: _vm.showEmail,
    attrs: {
      "id": "email"
    }
  }, [_c('h3', [_vm._v("Inserisci la tua email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailaddress),
      expression: "emailaddress"
    }],
    attrs: {
      "type": "email",
      "title": "email"
    },
    domProps: {
      "value": (_vm.emailaddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailaddress = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v("Invia")])]), _vm._v(" "), _c('div', {
    staticClass: "popup",
    class: _vm.showConfirmMail,
    attrs: {
      "id": "confirmMail"
    }
  }, [_c('h3', [_vm._v("Email inviata!")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.closeConfirmMail
    }
  }, [_vm._v("Ok")])]), _vm._v(" "), _c('div', {
    staticClass: "popup",
    class: _vm.showBuy,
    attrs: {
      "id": "buy"
    }
  }, [_c('h3', [_vm._v("Grazie!")]), _vm._v(" "), _c('p', [_vm._v("I tuoi nuovi occhiali ti aspettano in cassa")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/luxy",
      "id": "nav-prev"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/aft-1",
      "id": "nav-next"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "_content"
    }
  }, [_c('div', [_c('video', {
    staticClass: "video-webcam",
    attrs: {
      "id": "_webcam2"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_imageData2"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_faceSub2"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_threejs2"
    }
  }), _vm._v(" "), _c('canvas', {
    staticClass: "video-canvas",
    attrs: {
      "id": "_drawing2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cad2e82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Selfie.vue
// module id = 31
// module chunks = 0